import { Axios } from "../Hooks/useAxiosInstance";
import { useAppContext } from "../Context/AppContext";
import { API_ROUTE } from "../Config";


export const GeneralApi = () => {
    const { user } = useAppContext();

    const apis = ({ api_token }) => ({
        upload: async (data) => await uploadAttachment(data, api_token),
        getLeaderBoard: async (params) => await getLeaderBoard(params, api_token),
    })

    async function uploadAttachment(data, api_token) {
        const url = API_ROUTE.UPLOAD_ATTACHMENT;
        const option = {
            headers: {
                "Authorization": api_token,
                'Content-Type': 'multipart/form-data'
            }
        }
        return await Axios.post(url, data, option);
    }

    async function getLeaderBoard(params, api_token) {
        const url = API_ROUTE.GET_LEADERBOARD;
        const option = {
          headers: {
            Authorization: api_token,
          },
          params: params,
        };
        return await Axios.get(url, option);
      }

    return apis({ api_token: user.api_token });
}

